declare global {
  interface Window {
    MSStream?: any;
    MSInputMethodContext?: any;
  }
}

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isAndroid() {
  return (/android/i.test(navigator.userAgent));
}

export function isIE11() {
  return !!window.MSInputMethodContext && !!(document as any).documentMode;
}
